import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import LandingLayoutV2 from "../../layouts/landing-v2"

const PageLandingV2 = ({ blok, path }) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokEntry(filter: { slug: { eq: "global" } }) {
          edges {
            node {
              id
              name
              created_at
              uuid
              slug
              full_slug
              content 
              is_startpage
              parent_id 
              group_id
            }
          }
        }
      }
    `}
    render={data => {
      const globalData = JSON.parse(
        data.allStoryblokEntry.edges[0].node.content
      )
      return <LandingLayoutV2 globalData={globalData} blok={blok} path={path} />
    }}
  />
)

PageLandingV2.propTypes = {
  blok: PropTypes.shape({
    meta_data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    body: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default PageLandingV2
